import { render } from "./sale.vue?vue&type=template&id=378fcd8f&scoped=true"
const script = {}

import "./sale.vue?vue&type=style&index=0&id=378fcd8f&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-378fcd8f"]])

export default __exports__